import React from "react";
import { Card, Form, Input, Button } from "antd";
import { jwtDecode } from "jwt-decode";
import jwtEncode from 'jwt-encode';
import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL } from '../Components/Constant'; // Ensure this path is correct
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const AdminAuthentication = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const onFinish = async (values) => {
        try {
            const token = jwtEncode(
                { username: values.username, password: values.password },
                'SUPER_ADMIN_SECRET',
                { algorithm: 'HS256' }
            );

            const decodedToken = jwtDecode(token);

            const apiService = new ApiService(`${BASE_URL}/super_admin/login`, {
                'Content-Type': 'application/json',
            }, 'POST', {
                tokens: token,
            });

            const response = await apiService.makeCall();

            const tokenRes = response.token;
            const expiryDate = new Date(new Date().getTime() + 3 * 60 * 60 * 1000);
            Cookies.set('SuperAdminToken', tokenRes, { expires: expiryDate });
            navigate('/Admin');
        } catch (error) {
            console.error("Error during authentication:", error);
        } finally { }
    };

    return (
        <div
            style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#fff7e6", // 🔸 light orange background
            }}
        >
            <Card
                title="Enter Admin Credentials"
                style={{
                    width: 450,   // 🔸 increased width
                    minHeight: 200, // 🔸 increased height
                    borderRadius: "16px",
                    backgroundColor: "#fff2e6", // 🔸 very light orange card
                    boxShadow: "0 6px 18px rgba(0,0,0,0.1)", // 🔸 soft shadow
                }}
                headStyle={{
                    textAlign: "center",
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#d46b08", // 🔸 darker orange title
                }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                >
                    <Form.Item
                        name="username"
                        label="Username"
                        rules={[{ required: true, message: "Please enter your username!" }]}
                    >
                        <Input size="large" placeholder="Enter username" />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[{ required: true, message: "Please enter your password!" }]}
                    >
                        <Input.Password size="large" placeholder="Enter password" />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            block
                            size="large"
                            style={{
                                borderRadius: "8px",
                                backgroundColor: "#fa8c16", // 🔸 orange button
                                border: "none",
                            }}
                        >
                            Login
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default AdminAuthentication;
